var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoPushFusionHoriz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 394 95",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "circles"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.186,34.336c-3.162,3.188 -5.509,7.184 -6.704,11.651c-0.141,0.534 -0.495,2.002 -0.473,3.142c0.026,1.304 0.015,2.468 -0.003,3.326c0.002,0.106 0.003,0.211 0.003,0.317c0,0.402 -0.017,0.799 -0.052,1.193l0,0c-0.285,3.249 -1.722,6.169 -3.9,8.349l-0.003,0.007l-0.002,-0.002l-0.203,0.199c-0.185,0.177 -0.375,0.35 -0.57,0.517l-0.266,0.222c-0.053,0.043 -0.107,0.085 -0.16,0.128c-0.275,0.216 -0.558,0.422 -0.849,0.617l-0.05,0.033c-1.164,0.772 -2.455,1.369 -3.834,1.751c-0.054,0.015 -0.107,0.03 -0.161,0.044l-0.365,0.091l-0.246,0.055c-0.13,0.028 -0.261,0.054 -0.392,0.078c-0.021,0.004 -0.042,0.008 -0.062,0.011c-0.761,0.137 -1.545,0.209 -2.346,0.211l-0.043,0.001c-3.727,0 -7.103,-1.513 -9.548,-3.958c-2.444,-2.444 -3.957,-5.82 -3.957,-9.547l0,-0.044c0.003,-0.8 0.075,-1.584 0.211,-2.345c0.004,-0.021 0.008,-0.041 0.011,-0.062c0.024,-0.132 0.05,-0.262 0.078,-0.393l0.056,-0.245l0.091,-0.365c0.014,-0.054 0.028,-0.108 0.043,-0.161c0.383,-1.379 0.979,-2.67 1.752,-3.835l0.033,-0.049c0.194,-0.291 0.4,-0.574 0.617,-0.849c0.042,-0.054 0.085,-0.107 0.128,-0.16l0.222,-0.266c0.167,-0.195 0.339,-0.386 0.517,-0.571l0.198,-0.202l-0.002,-0.002l0.007,-0.003c2.18,-2.178 5.101,-3.615 8.349,-3.901l0.001,0c0.393,-0.034 0.791,-0.052 1.193,-0.052c0.105,0 0.211,0.002 0.316,0.004c0.859,-0.018 2.022,-0.029 3.327,-0.004c1.139,0.022 2.607,-0.332 3.142,-0.472c4.502,-1.205 8.525,-3.58 11.725,-6.78c3.2,-3.2 5.575,-7.223 6.78,-11.725c0.14,-0.535 0.494,-2.003 0.472,-3.142c-0.025,-1.305 -0.014,-2.468 0.004,-3.327c-0.002,-0.105 -0.004,-0.211 -0.004,-0.316c0,-0.402 0.018,-0.8 0.052,-1.193l0,-0.001c0.286,-3.248 1.723,-6.169 3.901,-8.349l0.003,-0.007l0.002,0.002l0.202,-0.198c0.185,-0.178 0.376,-0.35 0.571,-0.517l0.266,-0.222c0.053,-0.043 0.106,-0.086 0.16,-0.128c0.275,-0.217 0.558,-0.423 0.849,-0.617l0.049,-0.033c1.165,-0.773 2.456,-1.369 3.835,-1.752c0.053,-0.015 0.107,-0.029 0.161,-0.043l0.365,-0.091l0.245,-0.056c0.131,-0.028 0.261,-0.054 0.393,-0.078c0.021,-0.003 0.041,-0.007 0.062,-0.011c0.761,-0.136 1.545,-0.208 2.345,-0.211l0.044,0c3.727,0 7.103,1.513 9.547,3.957c2.445,2.445 3.958,5.821 3.958,9.548l-0.001,0.043c-0.002,0.801 -0.074,1.585 -0.211,2.346c-0.003,0.02 -0.007,0.041 -0.011,0.062c-0.024,0.131 -0.05,0.262 -0.078,0.392l-0.055,0.246l-0.091,0.365c-0.014,0.054 -0.029,0.107 -0.044,0.161c-0.382,1.379 -0.979,2.67 -1.751,3.834l-0.033,0.05c-0.195,0.291 -0.401,0.574 -0.617,0.849c-0.043,0.053 -0.085,0.107 -0.128,0.16l-0.222,0.266c-0.167,0.195 -0.34,0.385 -0.517,0.57l-0.199,0.203l0.002,0.002l-0.007,0.003c-2.18,2.178 -5.1,3.615 -8.349,3.9l0,0c-0.394,0.035 -0.791,0.052 -1.193,0.052c-0.106,0 -0.211,-0.001 -0.317,-0.003c-0.858,0.018 -2.022,0.029 -3.326,0.003c-1.14,-0.022 -2.608,0.332 -3.142,0.473c-4.502,1.204 -8.526,3.579 -11.726,6.779l-0.075,0.075Z",
    style: {
      fill: "#0e98fa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.083,
    cy: 22.48,
    r: 5.584,
    style: {
      fill: "#0e98fa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.512,
    cy: 63.614,
    r: 5.584,
    style: {
      fill: "#0e98fa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.11,
    cy: 17.232,
    r: 5.584,
    style: {
      fill: "#0e98fa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.809,
    cy: 79.303,
    r: 5.584,
    style: {
      fill: "#0e98fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.841,44.486c-1.682,-2.567 -2.333,-5.799 -1.539,-9.01c1.514,-6.122 7.714,-9.863 13.836,-8.349l0.07,0.018l0.07,0.017c6.121,1.516 9.86,7.718 8.343,13.839c-0.766,3.094 -2.729,5.58 -5.274,7.086c-6.133,2.823 -10.395,9.026 -10.395,16.216c0,4.148 1.418,7.966 3.796,10.998c1.474,2.49 2.011,5.537 1.262,8.565c-1.515,6.123 -7.715,9.864 -13.837,8.349l-0.069,-0.017l-0.07,-0.017c-6.122,-1.517 -9.86,-7.718 -8.344,-13.84c0.782,-3.156 2.809,-5.678 5.428,-7.174c6.021,-2.868 10.187,-9.011 10.187,-16.12c0,-3.951 -1.287,-7.604 -3.464,-10.561Z",
    style: {
      fill: "#0e98fa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.406,74.852l0,7.268c0,6.74 -5.465,12.205 -12.205,12.205c-6.741,0 -12.205,-5.465 -12.205,-12.205l0,-29.348c0,-11.474 9.302,-20.776 20.776,-20.776c11.474,0 20.776,9.302 20.776,20.776c0,9.522 -6.405,17.547 -15.142,20.003l0,0c-0.589,0.18 -1.039,0.285 -1.414,0.66c-0.375,0.375 -0.586,0.887 -0.586,1.417Z",
    style: {
      fill: "#0e98fa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "fusion"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.075,35.075l5.345,0l0,8.123l-5.345,0l0,18.972l-9.619,0l0,-18.972l-3.367,0l0,-8.123l3.367,0c0,-5.024 1.442,-12.025 10.742,-12.025c1.817,0 3.206,0.268 4.222,0.428l0,7.856c-0.375,-0.054 -0.962,-0.107 -1.604,-0.107c-2.779,0 -3.741,1.657 -3.741,3.848",
    style: {
      fill: "#0e98fa",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.148,35.075l0,27.095l-9.619,0l0,-2.886c-1.39,1.977 -3.688,3.58 -7.429,3.58c-8.443,0 -9.94,-6.84 -9.94,-10.795l0,-16.994l9.619,0l0,14.643c0,2.084 1.497,3.687 3.902,3.687c2.351,0 3.848,-1.603 3.848,-3.687l0,-14.643l9.619,0Z",
    style: {
      fill: "#0e98fa",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.418,53.779c0,5.718 -4.702,9.085 -12.665,9.085c-5.451,0 -11.009,-1.656 -12.132,-6.413l8.444,-2.618c0.268,1.015 1.176,2.244 3.581,2.244c1.817,0 2.779,-0.801 2.779,-1.923c0,-1.657 -2.298,-1.764 -5.451,-2.459c-5.237,-1.176 -8.497,-3.046 -8.497,-8.337c0,-5.665 5.29,-8.925 12.078,-8.925c4.649,0 9.512,2.245 10.688,6.841l-7.696,1.871c-0.374,-1.23 -1.336,-2.031 -2.939,-2.031c-1.71,0 -2.833,0.694 -2.833,1.977c0,1.657 2.459,1.87 4.597,2.298c6.84,1.443 10.046,3.42 10.046,8.39",
    style: {
      fill: "#0e98fa",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.892,35.075l9.619,0l0,27.094l-9.619,0l0,-27.094Zm-0.214,-7.589c0,-2.726 2.245,-4.97 5.023,-4.97c2.779,0 5.024,2.244 5.024,4.97c0,2.779 -2.245,5.024 -5.024,5.024c-2.778,0 -5.023,-2.245 -5.023,-5.024",
    style: {
      fill: "#0e98fa",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.598,48.649c0,-2.993 -2.031,-4.863 -4.81,-4.863c-2.779,0 -4.863,1.87 -4.863,4.863c0,2.992 2.084,4.81 4.863,4.81c2.779,0 4.81,-1.818 4.81,-4.81m9.726,0c0,8.283 -6.092,14.215 -14.536,14.215c-8.444,0 -14.536,-5.932 -14.536,-14.215c0,-8.283 6.092,-14.216 14.536,-14.216c8.444,0 14.536,5.933 14.536,14.216",
    style: {
      fill: "#0e98fa",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,45.229l0,16.94l-9.62,0l0,-14.589c0,-2.137 -1.496,-3.687 -3.847,-3.687c-2.352,0 -3.848,1.55 -3.848,3.687l0,14.589l-9.619,0l0,-27.094l9.619,0l0,2.886c1.389,-1.924 3.687,-3.528 7.375,-3.528c8.497,0 9.94,6.841 9.94,10.796",
    style: {
      fill: "#0e98fa",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "push"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.247,48.649c0,-5.451 -3.42,-9.62 -8.978,-9.62c-5.985,0 -9.406,4.275 -9.406,9.62c0,5.344 3.421,9.566 9.406,9.566c5.558,0 8.978,-4.115 8.978,-9.566m4.97,0c0,7.108 -5.023,14.215 -13.467,14.215c-4.703,0 -7.856,-1.923 -9.887,-4.489l0,14.109l-4.863,0l0,-37.409l4.863,0l0,3.794c2.031,-2.512 5.184,-4.436 9.887,-4.436c8.444,0 13.467,7.108 13.467,14.216",
    style: {
      fill: "#3f3e3e",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.182,35.075l0,27.095l-4.863,0l0,-3.741c-1.603,2.405 -4.275,4.435 -8.337,4.435c-6.092,0 -10.421,-5.077 -10.421,-10.795l0,-16.994l4.863,0l0,15.552c0,3.847 1.603,7.588 6.68,7.588c5.131,0 7.215,-4.382 7.215,-7.588l0,-15.552l4.863,0Z",
    style: {
      fill: "#3f3e3e",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.261,54.047c0,4.809 -3.42,8.817 -10.635,8.817c-5.344,0 -9.833,-2.137 -10.902,-6.199l4.756,-1.603c0.428,1.389 1.871,3.313 6.253,3.313c3.527,0 5.504,-1.443 5.504,-3.847c0,-3.154 -4.542,-3.154 -8.283,-4.009c-5.077,-1.122 -7.268,-3.58 -7.268,-7.589c0,-4.97 4.115,-8.496 9.994,-8.496c4.382,0 8.283,2.244 9.245,6.252l-4.543,1.229c-0.48,-1.496 -2.084,-3.1 -5.13,-3.1c-2.672,0 -4.649,1.497 -4.649,3.742c0,3.046 3.74,3.26 6.84,3.901c6.627,1.389 8.818,3.527 8.818,7.589",
    style: {
      fill: "#3f3e3e",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.012,45.229l0,16.94l-4.917,0l0,-15.551c0,-3.794 -1.603,-7.589 -6.68,-7.589c-5.13,0 -7.214,4.436 -7.214,7.589l0,15.551l-4.863,0l0,-37.409l4.863,0l0,14.109c1.603,-2.405 4.275,-4.436 8.39,-4.436c6.092,0 10.421,5.077 10.421,10.796",
    style: {
      fill: "#3f3e3e",
      fillRule: "nonzero"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPushFusionHoriz);
export default __webpack_public_path__ + "static/media/logoPushFusionHoriz.adc11a5621b9760a236eca27fc0ec819.svg";
export { ForwardRef as ReactComponent };